import styled from 'styled-components'
import { devices, setFlex } from '../../styles/themeStyles'

export const Wallet = styled.div`
  margin: auto;
  ${setFlex()};
  flex-direction: column;
  width: 100%;
  max-width: 600px;
  padding: 0 20px;
  ${devices.tablet} {
    max-width: 95vw;
  }
`

export const Section = styled.div`
  width: 100%;
  margin-bottom: 24px;
  background-color: ${({ theme }) => theme.colors.whiteTransparent};
  padding: 20px;
  border-radius: 8px;
`

export const SectionTitle = styled.h3`
  font-family: 'Cardo', 'Prompt', serif;
  font-size: 18px;
  margin: 0 0 12px 0;
  color: ${({ theme }) => theme.colors.brown1};
  letter-spacing: 0.5px;
`

export const BalanceCard = styled.div`
  text-align: center;
  padding: 24px 16px;
  background: linear-gradient(135deg, #f7f4ef 0%, #efede4 100%);
  border-radius: 8px;
`

export const BalanceLabel = styled.div`
  font-size: 12px;
  letter-spacing: 0.15em;
  color: ${({ theme }) => theme.colors.brown1};
  text-transform: uppercase;
`

export const BalanceValue = styled.div<{ negative?: boolean }>`
  font-family: 'Cardo', 'Prompt', serif;
  font-size: 42px;
  font-weight: bold;
  margin: 8px 0;
  color: ${({ negative, theme }) => (negative ? theme.colors.red : theme.colors.brown1)};
`

export const MemberInfo = styled.div`
  font-size: 13px;
  color: ${({ theme }) => theme.colors.grey2};
  margin-top: 4px;
`

export const ButtonRow = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 10px;
  margin-top: 16px;
  ${devices.mobile} {
    grid-template-columns: 1fr;
  }
`

export const PrimaryBtn = styled.a`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 44px;
  padding: 0 16px;
  background-color: ${({ theme }) => theme.colors.brown1};
  color: ${({ theme }) => theme.colors.white};
  font-family: 'Cardo', 'Prompt', serif;
  font-size: 14px;
  text-decoration: none;
  border-radius: 4px;
  letter-spacing: 0.5px;
  cursor: pointer;
  &:hover {
    opacity: 0.85;
    color: ${({ theme }) => theme.colors.white};
  }
`

export const SecondaryBtn = styled(PrimaryBtn)`
  background-color: transparent;
  color: ${({ theme }) => theme.colors.brown1};
  border: 1px solid ${({ theme }) => theme.colors.brown1};
  &:hover {
    color: ${({ theme }) => theme.colors.brown1};
    background-color: ${({ theme }) => theme.colors.brown3};
  }
`

export const TxList = styled.div`
  display: flex;
  flex-direction: column;
`

export const TxItem = styled.div`
  display: grid;
  grid-template-columns: auto 1fr auto;
  align-items: center;
  gap: 12px;
  padding: 12px 4px;
  border-bottom: 1px solid ${({ theme }) => theme.colors.brown3};
  &:last-child {
    border-bottom: none;
  }
`

export const TxIcon = styled.div<{ topup?: boolean }>`
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background-color: ${({ topup, theme }) => (topup ? theme.colors.success : theme.colors.cancel)};
  color: ${({ theme }) => theme.colors.white};
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  font-weight: bold;
`

export const TxBody = styled.div`
  display: flex;
  flex-direction: column;
`

export const TxLabel = styled.div`
  font-family: 'Cardo', 'Prompt', serif;
  font-size: 14px;
  color: ${({ theme }) => theme.colors.brown1};
`

export const TxTime = styled.div`
  font-size: 11px;
  color: ${({ theme }) => theme.colors.grey1};
  margin-top: 2px;
`

export const TxAmount = styled.div<{ topup?: boolean }>`
  font-family: 'Cardo', 'Prompt', serif;
  font-size: 16px;
  font-weight: bold;
  color: ${({ topup, theme }) => (topup ? theme.colors.success : theme.colors.cancel)};
`

export const Empty = styled.div`
  text-align: center;
  padding: 24px;
  color: ${({ theme }) => theme.colors.grey1};
  font-size: 13px;
`

export const InvitePanel = styled.div`
  background-color: ${({ theme }) => theme.colors.whiteTransparent};
  padding: 24px 20px;
  border-radius: 8px;
  text-align: center;
`

export const InviteHeader = styled.h2`
  font-family: 'Cardo', 'Prompt', serif;
  font-size: 22px;
  margin: 0 0 8px 0;
  color: ${({ theme }) => theme.colors.brown1};
`

export const InviteSubheader = styled.p`
  font-size: 14px;
  color: ${({ theme }) => theme.colors.grey2};
  margin: 0 0 24px 0;
  line-height: 1.6;
`

export const Divider = styled.div`
  height: 1px;
  background-color: ${({ theme }) => theme.colors.brown3};
  margin: 20px 0;
`

export const BenefitsTitle = styled.div`
  font-family: 'Cardo', 'Prompt', serif;
  font-size: 15px;
  font-weight: bold;
  color: ${({ theme }) => theme.colors.brown1};
  margin-bottom: 12px;
  text-align: left;
`

export const BenefitsList = styled.ul`
  text-align: left;
  list-style: none;
  padding: 0;
  margin: 0 0 8px 0;
`

export const BenefitItem = styled.li`
  font-size: 13px;
  color: ${({ theme }) => theme.colors.brown1};
  padding: 6px 0 6px 24px;
  position: relative;
  line-height: 1.5;
  &:before {
    content: '✓';
    position: absolute;
    left: 0;
    color: ${({ theme }) => theme.colors.success};
    font-weight: bold;
  }
`

export const StepsTitle = styled.div`
  font-family: 'Cardo', 'Prompt', serif;
  font-size: 15px;
  font-weight: bold;
  color: ${({ theme }) => theme.colors.brown1};
  margin-bottom: 12px;
  text-align: left;
`

export const StepsList = styled.ol`
  text-align: left;
  list-style: none;
  padding: 0;
  margin: 0;
  counter-reset: step;
`

export const StepItem = styled.li`
  font-size: 13px;
  color: ${({ theme }) => theme.colors.brown1};
  padding: 8px 0 8px 36px;
  position: relative;
  line-height: 1.5;
  counter-increment: step;
  &:before {
    content: counter(step);
    position: absolute;
    left: 0;
    top: 8px;
    width: 22px;
    height: 22px;
    line-height: 22px;
    text-align: center;
    border-radius: 50%;
    background-color: ${({ theme }) => theme.colors.brown1};
    color: ${({ theme }) => theme.colors.white};
    font-size: 11px;
    font-weight: bold;
  }
`

export const StepStrong = styled.span`
  font-weight: bold;
`

export const StepHint = styled.div`
  font-size: 12px;
  color: ${({ theme }) => theme.colors.grey1};
  margin-top: 2px;
`

export const CenteredBtnWrap = styled.div`
  display: flex;
  justify-content: center;
  margin: 12px 0 4px 0;
`

export const QrPanel = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: ${({ theme }) => theme.colors.white};
  padding: 16px;
  border-radius: 8px;
  margin: 16px 0;
`

export const QrCaption = styled.div`
  font-size: 12px;
  color: ${({ theme }) => theme.colors.grey2};
  margin-top: 8px;
  text-align: center;
`

export const FootnoteRow = styled.div`
  margin-top: 16px;
  padding-top: 16px;
  border-top: 1px solid ${({ theme }) => theme.colors.brown3};
  font-size: 12px;
  color: ${({ theme }) => theme.colors.grey1};
`

export const InlineLink = styled.a`
  color: ${({ theme }) => theme.colors.brown1};
  text-decoration: underline;
  &:hover {
    color: ${({ theme }) => theme.colors.brown1};
    opacity: 0.7;
  }
`

export const Spinner = styled.div`
  text-align: center;
  padding: 32px;
  color: ${({ theme }) => theme.colors.grey1};
  font-size: 13px;
`

/* ============================================================ */
/* Card topup modals (Phase 5.5)                                */
/* ============================================================ */

export const ModalOverlay = styled.div`
  position: fixed;
  inset: 0;
  z-index: 1000;
  background: rgba(0, 0, 0, 0.55);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
`

export const ModalCard = styled.div`
  background-color: ${({ theme }) => theme.colors.white};
  border-radius: 12px;
  padding: 20px;
  width: 100%;
  max-width: 380px;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.18);
`

export const ModalTitle = styled.h3`
  font-family: 'Cardo', 'Prompt', serif;
  font-size: 18px;
  margin: 0 0 16px 0;
  text-align: center;
  color: ${({ theme }) => theme.colors.brown1};
`

export const ModalCloseBtn = styled.button`
  display: block;
  width: 100%;
  margin-top: 8px;
  padding: 12px;
  background: none;
  border: none;
  color: ${({ theme }) => theme.colors.grey1};
  font-size: 13px;
  cursor: pointer;
  &:hover {
    color: ${({ theme }) => theme.colors.brown1};
  }
`

export const OptionButton = styled.button`
  display: block;
  width: 100%;
  padding: 14px 16px;
  margin-bottom: 8px;
  text-align: left;
  background-color: ${({ theme }) => theme.colors.white};
  border: 1px solid ${({ theme }) => theme.colors.brown3};
  border-radius: 10px;
  cursor: pointer;
  text-decoration: none;
  color: inherit;
  &:hover {
    border-color: ${({ theme }) => theme.colors.brown1};
  }
`

export const OptionButtonDisabled = styled.div`
  font-size: 12px;
  color: ${({ theme }) => theme.colors.grey1};
  text-align: center;
  padding: 8px 4px 4px;
`

export const OptionTitle = styled.div`
  font-family: 'Cardo', 'Prompt', serif;
  font-size: 14px;
  font-weight: 600;
  color: ${({ theme }) => theme.colors.brown1};
`

export const OptionHint = styled.div`
  font-size: 12px;
  color: ${({ theme }) => theme.colors.grey1};
  margin-top: 2px;
`

export const PresetGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 8px;
  margin-bottom: 12px;
`

export const PresetBtn = styled.button<{ selected?: boolean }>`
  padding: 14px 8px;
  border-radius: 8px;
  border: 1px solid ${({ selected, theme }) =>
    selected ? theme.colors.brown1 : theme.colors.brown3};
  background-color: ${({ selected, theme }) =>
    selected ? theme.colors.brown1 : theme.colors.white};
  color: ${({ selected, theme }) =>
    selected ? theme.colors.white : theme.colors.brown1};
  font-family: 'Cardo', 'Prompt', serif;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  &:hover {
    border-color: ${({ theme }) => theme.colors.brown1};
  }
`

export const AmountInput = styled.input`
  width: 100%;
  padding: 12px;
  border: 1px solid ${({ theme }) => theme.colors.brown3};
  border-radius: 8px;
  font-family: 'Cardo', 'Prompt', serif;
  font-size: 16px;
  margin-bottom: 12px;
  &:focus {
    outline: none;
    border-color: ${({ theme }) => theme.colors.brown1};
  }
`

export const FormInput = styled.input`
  width: 100%;
  padding: 12px;
  border: 1px solid ${({ theme }) => theme.colors.brown3};
  border-radius: 8px;
  font-size: 14px;
  margin-bottom: 8px;
  box-sizing: border-box;
  &:focus {
    outline: none;
    border-color: ${({ theme }) => theme.colors.brown1};
  }
`

export const FormRow = styled.div`
  display: flex;
  gap: 8px;
  margin-bottom: 8px;
`

export const FormInputFlex = styled(FormInput)`
  flex: 1;
  margin-bottom: 0;
`

export const FormInputCvv = styled(FormInput)`
  width: 90px;
  flex: none;
  margin-bottom: 0;
`

export const FormError = styled.div`
  background-color: #fee;
  border: 1px solid #fcc;
  color: #a00;
  padding: 10px;
  border-radius: 8px;
  margin-bottom: 12px;
  font-size: 13px;
`

export const SubmitBtn = styled.button`
  width: 100%;
  padding: 14px;
  background-color: ${({ theme }) => theme.colors.brown1};
  color: ${({ theme }) => theme.colors.white};
  border: none;
  border-radius: 8px;
  font-family: 'Cardo', 'Prompt', serif;
  font-weight: 600;
  font-size: 15px;
  cursor: pointer;
  letter-spacing: 0.5px;
  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
  &:hover:not(:disabled) {
    opacity: 0.9;
  }
`

export const AmountDisplay = styled.div`
  text-align: center;
  margin-bottom: 12px;
`

export const AmountDisplayLabel = styled.div`
  font-size: 13px;
  color: ${({ theme }) => theme.colors.grey2};
`

export const AmountDisplayValue = styled.div`
  font-family: 'Cardo', 'Prompt', serif;
  font-size: 28px;
  font-weight: 700;
  color: ${({ theme }) => theme.colors.brown1};
  margin-top: 2px;
`

export const ProcessingCard = styled.div`
  text-align: center;
  padding: 24px 12px;
`

export const ProcessingTitle = styled.div`
  font-family: 'Cardo', 'Prompt', serif;
  font-size: 20px;
  font-weight: 700;
  color: #b45309;
  margin-bottom: 12px;
`

export const ProcessingBox = styled.div`
  background-color: #fffbeb;
  border: 1px solid #fde68a;
  border-radius: 8px;
  padding: 12px;
  font-size: 13px;
  color: ${({ theme }) => theme.colors.brown1};
  line-height: 1.6;
`

export const ProcessingHint = styled.div`
  font-size: 12px;
  color: ${({ theme }) => theme.colors.grey1};
  margin-top: 12px;
  line-height: 1.5;
`

export const SuccessCard = styled.div`
  text-align: center;
  padding: 24px 12px;
`

export const SuccessTitle = styled.div`
  font-family: 'Cardo', 'Prompt', serif;
  font-size: 20px;
  font-weight: 700;
  color: ${({ theme }) => theme.colors.success};
  margin-bottom: 8px;
`

export const SuccessAmount = styled.div`
  font-family: 'Cardo', 'Prompt', serif;
  font-size: 32px;
  font-weight: 700;
  color: ${({ theme }) => theme.colors.success};
  margin-bottom: 16px;
`

export const SuccessBalanceBox = styled.div`
  background-color: ${({ theme }) => theme.colors.brown3};
  border-radius: 8px;
  padding: 14px;
  margin-bottom: 16px;
`

export const SuccessBalanceLabel = styled.div`
  font-size: 11px;
  letter-spacing: 0.12em;
  color: ${({ theme }) => theme.colors.grey1};
  text-transform: uppercase;
`

export const SuccessBalanceValue = styled.div<{ negative?: boolean }>`
  font-family: 'Cardo', 'Prompt', serif;
  font-size: 24px;
  font-weight: 700;
  color: ${({ negative, theme }) => (negative ? theme.colors.red : theme.colors.brown1)};
  margin-top: 4px;
`

export const FailCard = styled.div`
  text-align: center;
  padding: 24px 12px;
`

export const FailTitle = styled.div`
  font-family: 'Cardo', 'Prompt', serif;
  font-size: 20px;
  font-weight: 700;
  color: #b45309;
  margin-bottom: 12px;
`

export const FailBox = styled.div`
  background-color: #fef3c7;
  border: 1px solid #fde68a;
  border-radius: 8px;
  padding: 12px;
  font-size: 13px;
  color: ${({ theme }) => theme.colors.brown1};
  line-height: 1.5;
`

export const FailHint = styled.div`
  font-size: 12px;
  color: ${({ theme }) => theme.colors.grey1};
  margin-top: 12px;
`

export const PollingCard = styled.div`
  text-align: center;
  padding: 32px 16px;
`

export const PollingTitle = styled.div`
  font-family: 'Cardo', 'Prompt', serif;
  font-size: 16px;
  color: ${({ theme }) => theme.colors.brown1};
  margin-bottom: 4px;
`

export const PollingHint = styled.div`
  font-size: 12px;
  color: ${({ theme }) => theme.colors.grey1};
`
